import { useMutation } from '@tanstack/react-query';
import verifyCustomToken from './verifyCustomToken';

const USER_TYPE_CLOUDER = 'clouder';

export default function useVerifyCustomToken() {
  return useMutation({
    mutationKey: ['use-verify-custom-token'],
    mutationFn: (payload) =>
      verifyCustomToken({
        ...payload,
        user_type: USER_TYPE_CLOUDER,
      }),
  });
}
